import { Box, Button, Paper, Stack, Typography } from "@mui/material"
import { useEffect, useState, useReducer, memo } from "react"

import FilterParameter from "./FilterParameter"

const FilterClauses = (props) => {

	const [, forceUpdate]								= useReducer(x => x + 1, 0);

	const [hasErrors, setHasErrors]						= useState(false)

	useEffect(() => { 
		setHasErrors(props.error)
		forceUpdate()
	}, [props.error])

	const handleAddFilter = () => {
		if (props.onChange) props.onChange([...props.filterClauses, {field: '', operation: '', parameter: ''}])
	}

	const handleRemoveFilter = (index) => {
		let data = [...props.filterClauses];
		data.splice(index, 1)
		
		if (props.onChange) props.onChange(data)
	}

	const handleUpdateFilter = (e, index) => {
		let data = [...props.filterClauses]

		// Atualiza os dados do campo alterado
		data[index].field 		= e.field
		data[index].operation 	= e.operation
		data[index].parameter 	= e.parameter
		data[index].isValid		= e.field !== '' && e.operation !== '' && e.parameter !== ''

		if (props.onChange) props.onChange(data)
	}

	return (
		<Box>
			<Paper>
				<Stack direction='column' spacing={1} marginTop={1} padding={1} {...(hasErrors ? {border: 1, borderRadius:1, borderColor: '#d32f2f'} : null)}>
					<Typography variant="h6" {...(hasErrors ? {color: 'error'} : null)}>Filtros</Typography>
					{props.filterClauses && props.filterClauses.map((filterClause, index) => {
						return (
							<Stack direction={'row'} spacing={1} key={filterClause.field + index}>
								<FilterParameter 
									field={filterClause.field} 
									fields={props.fields}
									operation={filterClause.operation} 
									parameter={filterClause.parameter}
									filterClauses={props.filterClauses}
									error={hasErrors && !filterClause.isValid}
									onChange={(e) => handleUpdateFilter(e, index)}
								/>
								<Button variant="contained" onClick={() => handleRemoveFilter(index)}>Remover</Button>
							</Stack>
						)
					})}
					<Box display={'flex'} justifyContent={'center'}>
						<Button variant="contained" sx={{width: 250}} onClick={handleAddFilter}> +Adicionar filtro </Button>
					</Box>
				</Stack>			
			</Paper>
			{hasErrors ? (<Typography variant="caption" color={'error'} paddingLeft={1}>{props.helperText}</Typography>) : null }
		</Box>
	)
}

export default memo(FilterClauses)